module.exports = __webpack_public_path__ + "img/adava.c090efba.svg";